<div class="td col-order text-ellipsis">
  <span class="br-body-2">{{ container().omsOrderId }}</span>
</div>

<div class="td col-car gap-5">
  <bz-form-field class="flex" [label]="'Cars' | translate"
                 [error]="submitted() && carInvalid() ? ('This field is required' | translate) : ''">
    <bz-select class="flex"
               appBringozIdGenerator="threepl-voucher-container-car-select"
               [ariaLabel]="'Cars' | translate"
               [options]="carOptions()"
               [value]="container().carId"
               [disabled]="isEdit()"
               [searchable]="true"
               [searchPlaceholder]="'Search' | translate"
               size="sm"
               (valueChange)="onCarSelect($event)">
    </bz-select>
  </bz-form-field>
  @if (container().carId && !isEdit()) {
    <bz-switch appBringozIdGenerator="threepl-voucher-container-shared-checkbox"
               ariaLabel="closePacking"
               size="sm"
               [checked]="sharedCar()"
               (checkedChange)="onSharedToggle()">
      {{ 'Shared' | translate }}
    </bz-switch>
  }
</div>

<div class="td col-container">
  <bz-form-field class="flex" [label]="'Container' | translate">
    <bz-input appBringozIdGenerator="threepl-voucher-container-id-input" size="sm" [value]="container().id ?? ''" [disabled]="true"></bz-input>
  </bz-form-field>
</div>

<div class="td col-un">
  <bz-select class="flex"
             appBringozIdGenerator="threepl-voucher-container-un-select"
             [label]="'UN' | translate"
             [ariaLabel]="'UN' | translate"
             [options]="unOptions()"
             [value]="selectedHazardousMaterial()?.id ?? null"
             [disabled]="isEdit()"
             [searchable]="true"
             [searchPlaceholder]="'Search' | translate"
             size="sm"
             (valueChange)="onUnNumberSelect($event)">
  </bz-select>
</div>

<div class="td col-material">
  <bz-form-field class="flex" [label]="'Material Code' | translate"
                 [error]="submitted() && materialInvalid() ? ('This field is required' | translate) : ''">
    <bz-select class="flex"
               appBringozIdGenerator="threepl-voucher-container-material-select"
               [ariaLabel]="'Material Code' | translate"
               [options]="materialOptions()"
               [value]="container().materialInfo?.materialCode ?? null"
               [disabled]="isEdit()"
               [searchable]="true"
               [searchPlaceholder]="'Search' | translate"
               size="sm"
               (valueChange)="onMaterialSelect($event)">
    </bz-select>
  </bz-form-field>
</div>

<div class="td col-weight">
  <bz-form-field class="flex" [label]="'Weight' | translate" [required]="true"
                 [error]="submitted() && weightInvalid() ? ('This field is required' | translate) : ''">
    <bz-input appBringozIdGenerator="threepl-voucher-container-weight-input" type="number" size="sm" [value]="container().item?.weight ?? ''" [disabled]="true"></bz-input>
  </bz-form-field>
</div>

<div class="td col-package">
  @if (container().item?.type) {
    <!-- ui-fallback: package items stay an admin component -->
    <app-bringoz-package-item class="margin-right-5" [id]="container().item.type"></app-bringoz-package-item>
  }
</div>

<div class="td col-container-type">
  <bz-form-field class="flex" [label]="'Container Type' | translate"
                 [error]="submitted() && containerTypeInvalid() ? ('This field is required' | translate) : ''">
    <bz-select class="flex"
               appBringozIdGenerator="threepl-voucher-container-type-select"
               [ariaLabel]="'Container Type' | translate"
               [options]="containerTypes"
               [value]="container().containerType ?? null"
               [disabled]="isEdit()"
               size="sm"
               (valueChange)="onContainerTypeChange($event)">
    </bz-select>
  </bz-form-field>
</div>

<div class="td col-packing-group">
  <bz-select class="flex"
             appBringozIdGenerator="threepl-voucher-container-packing-group-select"
             [label]="'Packing Groups' | translate"
             [ariaLabel]="'Packing Groups' | translate"
             [options]="packingGroupOptions()"
             [value]="container().packingGroup ?? null"
             [disabled]="isEdit()"
             size="sm"
             (valueChange)="onPackingGroupChange($event)">
  </bz-select>
</div>

<div class="td col-flag">
  <bz-switch appBringozIdGenerator="threepl-voucher-container-is-empty-checkbox" ariaLabel="isEmpty" size="sm"
             [checked]="!!container().isEmpty" [disabled]="isEdit()" (checkedChange)="onFlagChange('isEmpty', $event)"></bz-switch>
</div>
<div class="td col-flag">
  <bz-switch appBringozIdGenerator="threepl-voucher-container-close-packing-checkbox" ariaLabel="closePacking" size="sm"
             [checked]="!!container().closePacking" [disabled]="isEdit()" (checkedChange)="onFlagChange('closePacking', $event)"></bz-switch>
</div>
<div class="td col-flag">
  <bz-switch appBringozIdGenerator="threepl-voucher-container-middle-location-checkbox" ariaLabel="middleLocation" size="sm"
             [checked]="!!container().middleLocation" [disabled]="isEdit()" (checkedChange)="onFlagChange('middleLocation', $event)"></bz-switch>
</div>
<div class="td col-flag">
  <bz-switch appBringozIdGenerator="threepl-voucher-container-weighted-checkbox" ariaLabel="weighted" size="sm"
             [checked]="!!container().weighted" [disabled]="isEdit()" (checkedChange)="onFlagChange('weighted', $event)"></bz-switch>
</div>
<div class="td col-flag">
  <bz-switch appBringozIdGenerator="threepl-voucher-container-content-declared-checkbox" ariaLabel="contentDeclared" size="sm"
             [checked]="!!container().contentDeclared" [disabled]="isEdit()" (checkedChange)="onFlagChange('contentDeclared', $event)"></bz-switch>
</div>

<div class="td col-flag layout-align-center-center">
  @if (!isEdit()) {
    <span container="body" [ngbTooltip]="'Delete' | translate">
      <bz-button variant="tertiary"
                 appBringozIdGenerator="threepl-voucher-container-delete-button"
                 [ariaLabel]="'Delete' | translate"
                 (clicked)="remove.emit(container())">
        <bz-icon [icon]="trashIcon"></bz-icon>
      </bz-button>
    </span>
  }
</div>
